import { ApolloClient, InMemoryCache, from } from '@apollo/client/core';

import { errorHandle } from '@/api/apollo-client/ErrorHandle';
import { authMiddleware } from '@/api/apollo-client/AuthMiddleware';
import { splitLink } from '@/api/apollo-client/SplitLink';
import { retryLink } from '@/api/apollo-client/RetryLink';
import { relayStylePagination } from '@apollo/client/utilities';

const processSubscriptionNode = () => ({
  merge(_, incoming, { cache }) {
    if (incoming.event) {
      const [event, type, id] = incoming.event.split(' ');
      if (event === SUB_EVENT_TYPES.delete) {
        cache.evict({
          id: `${type}:${id}`
        });
      }
    }
  }
});

const SUB_EVENT_TYPES = {
  insert: 'insert',
  update: 'update',
  delete: 'delete'
};

const sortByDate = (a, b) => {
  return new Date(b) - new Date(a);
};

let client;

client = new ApolloClient({
  link: from([errorHandle, authMiddleware, splitLink]),
  cache: new InMemoryCache({
    // addTypename: false,
    typePolicies: {
      Query: {
        fields: {
          notificationDeliveriesConnection: relayStylePagination([
            'filter',
            'orderBy'
          ])
        }
      },
      Subscription: {
        fields: {
          listen: processSubscriptionNode(),
          Objects: processSubscriptionNode(),
          ObjectsToObject: processSubscriptionNode(),
          Schemas: processSubscriptionNode(),
          UserProfile: processSubscriptionNode()
        }
      }
    }
  }),
  watchQuery: {
    errorPolicy: 'all'
  },
  query: {
    errorPolicy: 'all'
  },
  ssrMode: false,
  ssrForceFetchDelay: 0,
  connectToDevTools: process.env.NODE_ENV !== 'production'
});

export default client;
